module.exports = __webpack_public_path__ + "img/logo2_flatprime.f60e4a8c.svg";